import { makeStyles } from 'makeStyles';

export const useStyles = makeStyles()((theme) => ({
  sortIconWrapper: {
    height: 19,
    paddingLeft: 8,
  },
  sortIcon: {
    fontSize: 16,
  },
  hoveredRow: {},
  activeRow: {
    backgroundColor: '#f4f9ff',
  },
  clickableRow: {
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#f6f6f8',
    },
  },
  clickable: {
    cursor: 'pointer',
  },
  selected: {
    backgroundColor: '#EDF4FC',
  },
  border: {
    border: '1px solid #eaecf2',
  },
  sortable: {
    cursor: 'pointer',
    '&:hover': {
      height: 40,
      backgroundColor: '#f6f6f8',
    },
  },
  participantsTable: {
    marginTop: 20,
    '& .MuiTableCell-head': {
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1),
      fontWeight: 900,
      borderBottom: `2px solid rgba(224, 224, 224, 1)`,
    },
  },
  paginationSpacer: {
    display: 'none',
  },
  paginationCaption: {
    fontWeight: 'bold',
    color: '#2d3236',
    fontSize: 13,
  },
  select: {
    '& div': {
      paddingTop: 0,
      paddingBottom: 0,
      lineHeight: 1.43,
      fontWeight: 'bold',
      color: '#2d3236',
      fontSize: 13,
    },
  },
  selectHidden: {
    display: 'none',
  },
  paginationActions: {
    display: 'flex',
    marginLeft: 'auto',
  },
  itemsContainer: {
    display: 'flex',
    columnGap: 13,
    justifyContent: 'space-between',
  },
  paginationItem: {
    borderRadius: 4,
    fontSize: 14,
    fontWeight: 500,
    textAlign: 'center',
    color: '#737680',
    width: 35,
    height: 31,
    padding: '5px 14px 5px 13px',
    '&:hover': {
      backgroundColor: '#f6f6f8',
    },
  },
  paginationItemEllipsis: {
    color: '#737680',
    fontSize: 14,
    alignItems: 'center',
  },
  paginationItemSelected: {
    width: 35,
    height: 31,
    padding: '5px 14px 5px 13px',
    borderRadius: 4,
    border: 'solid 1px #9ab3ce',
    backgroundColor: '#f4f9ff !important',
    fontSize: 14,
    fontWeight: 500,
    letterSpacing: 0.14,
    textAlign: 'center',
    color: '#35689d',
  },
  menuItem: {
    fontSize: '12px',
  },

  toolbar: {
    padding: 0,
  },
  buttonNext: {
    textTransform: 'none',
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },

  buttonPrevious: {
    textTransform: 'none',
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
}));
